import React from 'react';
import { useIntl } from 'react-intl';

import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { Menu } from '~/eds/src/components/Menu/Menu';
import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';

interface Props {
  openTagClauseModal: () => void;
  openRemoveProvisionModal: () => void;
  selectedProvision: string | null;
}

export const EditProvision = ({
  openTagClauseModal,
  openRemoveProvisionModal,
  selectedProvision,
}: Props) => {
  const deprecateEditProvision = useFlag(FlagType.DeprecateEditProvision);
  const intl = useIntl();
  const items = [];
  if (!!selectedProvision) {
    if (!deprecateEditProvision) {
      items.push({
        label: intl.formatMessage({
          id: 'EditProvision.editClauseLabel',
          defaultMessage: 'Edit Clause',
          description: 'Label for edit clause menu item',
        }),
        value: 'edit',
        onClick: openTagClauseModal,
        leftIcon: 'edit' as const,
        ariaLabel: intl.formatMessage({
          id: 'EditProvision.editClauseAriaLabel',
          defaultMessage: 'edit clause',
          description: 'Aria label for edit clause action',
        }),
      });
    }
    items.push({
      label: intl.formatMessage({
        id: 'EditProvision.removeClauseLabel',
        defaultMessage: 'Remove Clause',
        description: 'Label for remove clause menu item',
      }),
      value: 'remove',
      onClick: openRemoveProvisionModal,
      leftIcon: 'trash' as const,
      ariaLabel: intl.formatMessage({
        id: 'EditProvision.removeClauseAriaLabel',
        defaultMessage: 'remove clause',
        description: 'Aria label for remove clause action',
      }),
    });
  } else {
    items.push({
      label: intl.formatMessage({
        id: 'EditProvision.tagClauseLabel',
        defaultMessage: 'Tag a Clause',
        description: 'Label for tag clause menu item',
      }),
      onClick: openTagClauseModal,
      value: 'tag',
      leftIcon: 'tag' as const,
      ariaLabel: intl.formatMessage({
        id: 'EditProvision.tagClauseAriaLabel',
        defaultMessage: 'tag clause',
        description: 'Aria label for tag clause action',
      }),
    });
  }

  return (
    <Menu
      name={intl.formatMessage({
        id: 'EditProvision.menuName',
        defaultMessage: 'edit clauses',
        description: 'Name for edit clauses menu',
      })}
      trigger={<IconButton icon="edit" />}
      options={items}
    />
  );
};
